exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui.dropdown[data-v-6dcd0a32]{position:absolute}.ui.dropdown>.menu[data-v-6dcd0a32]{display:block}", ""]);

// exports
